import { render, staticRenderFns } from "./value_stream_empty_state.vue?vue&type=template&id=089391c6"
import script from "./value_stream_empty_state.vue?vue&type=script&lang=js"
export * from "./value_stream_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports